import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { fetchLastFiles } from "../../api/files";
import GridMenu from "../../components/grid-menu/GridMenu";
import Topbar from "../../components/topbar/admin/Topbar";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../store/StoreContext";
import _ from "lodash";

const conteinerStyle = { maxWidth: "100%", zIndex: 1 };

const AdminLayout = () => {
  const { setLastFiles } = useContext(StoreContext);
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);

  useEffect(() => {
    fetchLastFiles(5)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);
        const documents = _.orderBy(
          data?.data?.documents || [],
          ["timestamp"],
          ["desc"]
        );
        setLastFiles(documents);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });
  }, []);

  return (
    <div className="w-100 smu-bg-body">
      <div className="admin-wrapper scroll-container">
        <div className="top-bg" />
        <Topbar />

        <Container className="px-0 mt-4 mx-0 h-100" style={conteinerStyle}>
          <Row className="h-100">
            <Col col={12} className={isMenuCollapsed ? "col-1" : "col-4"}>
              <GridMenu 
                isCollapsed={isMenuCollapsed} 
                onToggle={() => setIsMenuCollapsed(!isMenuCollapsed)} 
              />
            </Col>
            <Col col={12} className={isMenuCollapsed ? "col-11" : "col-8"}>
              <Outlet />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AdminLayout;
